/* eslint-disable react/forbid-elements */
import * as React from 'react';

export const ActionIcon = () => (
  <svg width="48" height="64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity=".6" d="M48 47.186L24.005 64 0 47.186V0h48v47.186z" fill="#fff" />
    <path
      d="M24 7.874c-8.961 0-16.226 7.265-16.226 16.226 0 4.377 1.733 8.348 4.55 11.267l-.74.674a17.169 17.169 0 01-4.81-11.94c0-9.515 7.712-17.227 17.226-17.227a17.19 17.19 0 0113.184 6.139l-.747.665A16.192 16.192 0 0024 7.874z"
      fill="url(#action_paint0_linear)"
    />
    <path
      d="M24 40.326c8.961 0 16.226-7.264 16.226-16.226a16.16 16.16 0 00-3.79-10.422l.748-.665A17.157 17.157 0 0141.226 24.1c0 9.514-7.712 17.226-17.226 17.226a17.176 17.176 0 01-12.415-5.285l.738-.674A16.179 16.179 0 0024 40.327z"
      fill="url(#action_paint1_linear)"
    />
    <path
      d="M24 42.2c9.996 0 18.1-8.104 18.1-18.1C42.1 14.104 33.996 6 24 6 14.004 6 5.9 14.104 5.9 24.1c0 9.996 8.104 18.1 18.1 18.1z"
      stroke="#3AC400"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M23.97 5.978c-9.994 0-18.096 8.101-18.096 18.095a18.054 18.054 0 006.314 13.735l-.731.66a19.029 19.029 0 01-6.561-14.395C4.896 13.54 13.436 5 23.969 5c6.166 0 11.648 2.926 15.135 7.464l-.838.516c-3.31-4.26-8.483-7.002-14.297-7.002z"
      fill="url(#action_paint2_linear)"
    />
    <path d="M15.098 22.2l-6.02 5.41.875-.25 5.649-5.09-.504-.07z" fill="#66E530" />
    <path d="M15.102 22.203l.492.063-2.805-7.047-.703-.516 3.016 7.5z" fill="#45CA0D" />
    <path d="M19.992 16l-7.906-1.297.719.516 7.437 1.21-.25-.429z" fill="#E1FFD4" />
    <path d="M24 8.89l-4 7.118.25.414L24 9.727V8.89z" fill="#97F56F" />
    <path d="M24.008 9.734v-.843l4.008 7.093-.243.43-3.765-6.68z" fill="#3EC605" />
    <path d="M35.227 15.188l-7.446 1.226.227-.43 7.898-1.289-.68.492z" fill="#3EC605" />
    <path d="M35.227 15.188l.68-.485-2.985 7.477-.516.086 2.82-7.078z" fill="#4ACD13" />
    <path d="M38.063 27.367l-5.649-5.101.5-.086 5.984 5.43-.836-.243z" fill="#60D92D" />
    <path d="M31.203 29.898a1597.65 1597.65 0 017.695-2.296l-.828-.235-7.273 2.172.406.36z" fill="#6EE13E" />
    <path d="M30.234 37.18l.563-7.64.414.358-.61 8.094-.367-.812z" fill="#7CE84F" />
    <path d="M24.008 33.398l6.594 4.594-.375-.812-6.22-4.344v.562z" fill="#5FD82C" />
    <path d="M17.781 37.172l6.227-4.336v.555l-6.602 4.601.375-.82z" fill="#3CC502" />
    <path d="M16.805 29.906l.601 8.078.36-.804-.563-7.64-.398.366z" fill="#3BC501" />
    <path d="M9.953 27.367l7.25 2.172-.398.367-7.711-2.304.86-.235z" fill="#3BC501" />
    <path
      d="M24 9.718l3.775 6.7 7.456-1.226L32.4 22.27l5.663 5.097-7.268 2.17-.566 7.645L24 32.841l-6.229 4.341-.566-7.644-7.267-2.171L15.6 22.27l-2.831-7.078 7.456 1.227L24 9.718z"
      fill="#3AC500"
    />
    <path
      d="M24 9.718l3.775 6.7 7.456-1.226L32.4 22.27l5.663 5.097-7.268 2.17-.566 7.645L24 32.841l-6.229 4.341-.566-7.644-7.267-2.171L15.6 22.27l-2.831-7.078 7.456 1.227L24 9.718z"
      fill="url(#action_paint3_linear)"
      style={{ mixBlendMode: 'lighten' }}
    />
    <defs>
      <linearGradient id="action_paint0_linear" x1="37.184" y1="13" x2="12" y2="36.041" gradientUnits="userSpaceOnUse">
        <stop stopColor="#3AC400" />
        <stop offset=".5" stopColor="#61E42A" />
        <stop offset="1" stopColor="#3AC400" />
      </linearGradient>
      <linearGradient
        id="action_paint1_linear"
        x1="35.625"
        y1="12.25"
        x2="12.063"
        y2="36"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3AC400" />
        <stop offset=".584" stopColor="#7DF14C" />
        <stop offset="1" stopColor="#3AC400" />
      </linearGradient>
      <linearGradient
        id="action_paint2_linear"
        x1="39.104"
        y1="12.336"
        x2="10.337"
        y2="36.177"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3AC400" />
        <stop offset=".484" stopColor="#fff" />
        <stop offset="1" stopColor="#3AC400" />
      </linearGradient>
      <linearGradient id="action_paint3_linear" x1="12" y1="14" x2="36.5" y2="33.5" gradientUnits="userSpaceOnUse">
        <stop offset=".034" stopColor="#77F143" />
        <stop offset=".494" stopColor="#50D717" />
        <stop offset=".822" stopColor="#3AC400" />
      </linearGradient>
    </defs>
  </svg>
);

ActionIcon.displayName = 'ActionIcon';
